import { Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Login from './pages/Login';
import PrivateRoute from "../src/components/common/PrivateRoute";
import Layout from "../src/components/common/Layout";
import Dashboard from './pages/Dashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Inventory from './pages/Inventory';
import Inspection from './pages/Inspection';
import Profile from './pages/Profile';
import Audit from './pages/Audit';
import YardDesigner from './pages/YardDesigner';

function App() {
  return (
    <Routes>
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<PrivateRoute element={Layout} />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/yard-designer" element={<YardDesigner />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/inspection" element={<Inspection />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/profile" element={<Profile />} />
      </Route>
    </Routes>
  );
}

export default App;
